export const automationRoutes = [
	{
		path: "automation/:id",
		name: "Automation",
		component: () => import('../pages/automation-page.vue'),
	},
];
